import { Box, Text } from "@chakra-ui/react";
import type { DateRowItem } from "@models/Schedule";
import moment from "moment";

interface Props {
	dateItem: DateRowItem;
}

const MonthDateItem = ({ dateItem }: Props) => {
	return (
		<Box
			minWidth={"42px"}
			height={"100%"}
			borderBottom={"1px solid #DEDEDE"}
			key={dateItem.date}
			display={"flex"}
			alignItems={"center"}
			justifyContent={"center"}
		>
			<Box
				width={"27px"}
				height={"27px"}
				borderRadius={"50%"}
				display={"flex"}
				alignItems={"center"}
				justifyContent={"center"}
				backgroundColor={dateItem.isToday ? "#DFEAF1" : "#FFFFFF"}
				color={dateItem.isWeekend ? "#C44747" : "#353535"}
			>
				<Text margin={0} fontSize={"14px"} lineHeight={1}>
					{moment(dateItem.date).format("DD")}
				</Text>
			</Box>
		</Box>
	);
};

export default MonthDateItem;
